import type {ReviewTimelineEvent, TimelineSummary} from '../../../../routes/route-payload-types'

export const pluralize = (count: number, singular: string, plural: string) => (count === 1 ? singular : plural)

export const sumReviewComments = (events: ReviewTimelineEvent[]) =>
  events.reduce((sum, e) => sum + (e.additionalInfo?.commentCount ?? 0), 0)

// Per-row presence predicates. Each row component uses its predicate for its null guard, and
// `hasSidebarActivity` ORs them so the empty state can never drift from what the rows render.
export const hasCommits = (s: TimelineSummary) => s.commits.count > 0
export const hasBaseForce = (s: TimelineSummary) => s.baseChanged.count > 0 || s.forcePushed.count > 0
export const hasApprovals = (s: TimelineSummary) => s.approvals.count > 0
export const hasChangesRequested = (s: TimelineSummary) => s.changesRequested.count > 0
export const hasComments = (s: TimelineSummary) => s.comments.count > 0
export const hasIssueComments = (s: TimelineSummary) => s.issueComments.count > 0

export const hasState = (s: TimelineSummary) =>
  s.closed.count > 0 ||
  s.reopened.count > 0 ||
  s.markedAsDraft.count > 0 ||
  s.readyForReview.count > 0 ||
  s.merged.count > 0

export const hasReviewRequests = (s: TimelineSummary) => s.reviewRequested.count > 0

export const hasSidebarActivity = (summary: TimelineSummary) =>
  hasCommits(summary) ||
  hasBaseForce(summary) ||
  hasApprovals(summary) ||
  hasChangesRequested(summary) ||
  hasComments(summary) ||
  hasIssueComments(summary) ||
  hasState(summary) ||
  hasReviewRequests(summary)
